import { render, staticRenderFns } from "./consume.vue?vue&type=template&id=2a0d988f&scoped=true"
import script from "./consume.vue?vue&type=script&lang=js"
export * from "./consume.vue?vue&type=script&lang=js"
import style0 from "./consume.vue?vue&type=style&index=0&id=2a0d988f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0d988f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a0d988f')) {
      api.createRecord('2a0d988f', component.options)
    } else {
      api.reload('2a0d988f', component.options)
    }
    module.hot.accept("./consume.vue?vue&type=template&id=2a0d988f&scoped=true", function () {
      api.rerender('2a0d988f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/administration/material/fixed/components/consume.vue"
export default component.exports